
import React from 'react'

export default function Fundprioriti() {
  return (
    <section className='mt-5 mb-5'>
        <div className='container'>
            <div className='row'>
                <div className='col-12'>

                    <div className='mb-3 '>
                        <h4 className='font-italic d-inline p-1 bg-warning'>Funding priorities</h4><br></br>
                    </div>

                    <div> 
                        <p>
                        The level of service the NIASSC can provide to undertake invasive species management depends on the amount of funding available from the Government of Antigua and Barbuda and external sources. The following priorities related to invasive species control appear for the most part in the Antigua and Barbuda National Strategic Biodiversity ActionPlan (2014 – 2020).  This list of priorities does not include consideration of funding for work required to train operational staff, review operational procedures or incorporate invasive species management(reporting and controlling) in open space,protected areas and sportsgrounds.  These are imperative in achieving the objectives of this plan.
                        </p>

                    </div>

                    <div>
                        <p>Priorities for NIASSC Funding:</p>

                        <ul>
                            <ol>a. Prioritize pest plant, pathogen and animal control programs in high biodiversity protected areas and private land where there is an identified immediate and unacceptable threat to a biodiversity asset.</ol>
                            <ol>b. Continue to recruit staff with excellent technical knowledge and resources to provide education and expert advice to landholders and community groups.</ol>
                            <ol>c. Update and align existing environmental education programs and resources related to invasive species identification and management to align with education and sustainability principles. </ol>
                            <ol>d. Provide innovative and targeted educational programs and material to raise community awareness.</ol>
                            <ol>c. Organize training in invasive alien species identification and management for landholders and community groups to develop skills and knowledge. </ol>
                            <ol>e. Build partnerships and strong networks between all land managers to facilitate a coordinated approach to invasive species management. </ol>
                            <ol>f. Make funding incentives available for invasive species management to friends and landcare groups and landholders in areas identified as supporting high biodiversity and agricultural values.</ol>
                            <ol>g. Seek funding for invasive species management in protected areas. </ol>
                            <ol>i. Seek funding for targeted invasive species management on government land to complement landcare activities and protect high agricultural assets. Support establishment and operation of friends and landcare groups in areas identified as supporting high biodiversity values</ol>
                            <ol>j. Support ongoing ecological management of protected areas. .</ol>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}
